module.exports = __webpack_public_path__ + "02_hair_brown.f5f7e464.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/02_hair_brown.png
// module id = sWIr
// module chunks = 0